export default __webpack_public_path__ + "static/media/img-64.c0f65ae3.jpg";